import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="150" height="150" viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#51565C"
        strokeWidth="3.5"
        d="M75 116.067c-22.644 0-41.067-18.423-41.067-41.067 0-22.644 18.423-41.067 41.067-41.067 22.644 0 41.067 18.423 41.067 41.067 0 22.644-18.423 41.067-41.067 41.067z"
      />
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M75 78.006A3.01 3.01 0 0 1 71.994 75 3.01 3.01 0 0 1 75 71.994 3.01 3.01 0 0 1 78.006 75 3.01 3.01 0 0 1 75 78.006z"
      />
      <path fill="#7BB835" d="M71.447 40.292h8.199v8.199h-8.199z" />
      <path fill="#15539F" d="M71.447 102.602h8.199v8.199h-8.199z" />
      <path fill="#53A2D9" d="M40.292 70.9h8.199v8.2h-8.2zM103.15 70.9h8.198v8.2h-8.199z" />
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M75.732 76.366l-2.098-1.148 16.485-30.553 2.098 1.148z"
      />
    </g>
  </Svg>
)
